import { useMemo } from "react";
import { sortBy, sortByCustom, SortOrder, type SortOrderType } from "@repo/utils";
import { SortBy, type ExplorerItem, type SortType, type StatusGroup } from "../task.types";

export const useTaskSorting = (
  items: StatusGroup[],
  sortType: SortType = SortBy.Workflow,
  order: SortOrderType = SortOrder.Ascending
) => {
  const sortedGroups = useMemo(
    () =>
      sortBy(items, "id", order).map((group) => ({
        ...group,
        children: sortByCustom(group.children, (child) => child.name, SortOrder.Ascending),
      })),
    [items, order]
  );

  const displayItems = useMemo<ExplorerItem[]>(() => {
    if (sortType === SortBy.Name) {
      return sortByCustom(
        items.flatMap((group) => group.children),
        (item) => item.name,
        order
      );
    }
    return sortedGroups;
  }, [items, sortType, order, sortedGroups]);

  return { sortedGroups, displayItems };
};
